import { createFileRoute } from '@tanstack/react-router'
import LayoutContentArea from '@/components/layout/LayoutContentArea'

export const Route = createFileRoute('/$leaid/_error-wrapper/records/quick-search')({
  component: () => 
    <LayoutContentArea 
      headingText="Quick Search"
    >
      <p>Content in development.</p>
    </LayoutContentArea>
})
